import * as Comlink from "comlink";

import Worker from "../workers/audio.worker?worker";

export const worker = Comlink.wrap(new Worker());
